export const ARCHIVE_STATUS_ENTITY_TYPES = {
  trackedOpportunities: "tracked-opportunities",
  proposals: "proposals",
  contracts: "contracts",
  miscAnalysis: "misc-analysis",
};

export const ARCHIVE_STATUS_TAB_LABELS = {
  [ARCHIVE_STATUS_ENTITY_TYPES.trackedOpportunities]: "Tracked Opportunities",
  [ARCHIVE_STATUS_ENTITY_TYPES.proposals]: "Proposals",
  [ARCHIVE_STATUS_ENTITY_TYPES.contracts]: "Contracts",
  [ARCHIVE_STATUS_ENTITY_TYPES.miscAnalysis]: "Misc Analysis",
};

export const ARCHIVE_STATUS_COUNT_HEADERS = {
  [ARCHIVE_STATUS_ENTITY_TYPES.trackedOpportunities]: "Opportunities Archived",
  [ARCHIVE_STATUS_ENTITY_TYPES.proposals]: "Proposals Archived",
  [ARCHIVE_STATUS_ENTITY_TYPES.contracts]: "Contracts Archived",
  [ARCHIVE_STATUS_ENTITY_TYPES.miscAnalysis]: "Analyses Archived",
};

export const ARCHIVE_STATUS_ITEM_NOUNS = {
  [ARCHIVE_STATUS_ENTITY_TYPES.trackedOpportunities]: "opportunities",
  [ARCHIVE_STATUS_ENTITY_TYPES.proposals]: "proposals",
  [ARCHIVE_STATUS_ENTITY_TYPES.contracts]: "contracts",
  [ARCHIVE_STATUS_ENTITY_TYPES.miscAnalysis]: "analyses",
};

export const ARCHIVE_STATUS_BASE_URL = "/api/archive-statuses";
